module.exports = __webpack_public_path__ + "img/交通@0.5x.8d7e6352.png";